const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";").map(c => c.trim());
    for (let c of ca) {
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const getLocalStorage = (name) => {
    const itemStr = localStorage.getItem(name);
    if (!itemStr) return null;

    let item;
    try {
        item = JSON.parse(itemStr);
    } catch (e) {
        localStorage.removeItem(name);
        return null;
    }

    if (
        typeof item !== 'object' ||
        !item.hasOwnProperty('expires') ||
        !item.hasOwnProperty('value')
    ) {
        localStorage.removeItem(name);
        return null;
    }

    const now    = new Date();
    const expiry = new Date(item.expires);
    if (now > expiry) {
        localStorage.removeItem(name);
        return null;
    }

    return item.value;
};

MktoForms2.whenReady((form) => {
    const utm_source   = getCookie('utm_source')   || getLocalStorage('utm_source');
    const utm_medium   = getCookie('utm_medium')   || getLocalStorage('utm_medium');
    const utm_campaign = getCookie('utm_campaign') || getLocalStorage('utm_campaign');
    const utm_term     = getCookie('utm_term')     || getLocalStorage('utm_term');
    const utm_content  = getCookie('utm_content')  || getLocalStorage('utm_content');

    const hiddenFields = {};
    const utmParams = { utm_source, utm_medium, utm_campaign, utm_term, utm_content };

    Object.entries(utmParams).forEach(([key, value]) => {
        if (!value) return;
        hiddenFields[`${key}__c`] = value;
        hiddenFields[key]        = value;
    });

    form.setValues(hiddenFields);
});
